export default "__VITE_ASSET__CBDw1itz__"